import parse, {
  isValidPhoneNumber,
  CountryCode as CountryCodeFromLibPhoneNumber,
  PhoneNumber,
} from 'libphonenumber-js';

import { EXCLUDED_COUNTRIES } from '../../../constants/phone';

import { getDialCode, PhoneCountryCode } from './country-codes-config';

export type PhoneArgs = { dialCode: string; phoneNumber: string; countryCode: string };

type CheckPhoneNumberValidityProps = Omit<PhoneArgs, 'phoneNumber'> & {
  parsedPhoneNumber: PhoneNumber | undefined;
  isPossibleNumber: boolean;
};

export const checkPhoneNumberValidity = ({
  countryCode,
  dialCode,
  parsedPhoneNumber,
  isPossibleNumber,
}: CheckPhoneNumberValidityProps) => {
  const isMatchingDialCode = getDialCode(countryCode as PhoneCountryCode) === dialCode;
  const isAllowedCountry = !EXCLUDED_COUNTRIES.some(
    (country) => country.toLowerCase() === parsedPhoneNumber?.country?.toLowerCase(),
  ); // TODO: check if this is correct

  return !!parsedPhoneNumber && isPossibleNumber && isMatchingDialCode && isAllowedCountry;
};

export const phoneValidation = ({ countryCode, dialCode, phoneNumber }: PhoneArgs) => {
  const parsedPhoneNumber = parse(`${dialCode}${phoneNumber}`);
  // isValidPhoneNumber is a function from libphonenumber-js so here I can cast
  // the countryCode to CountryCodeFromLibPhoneNumber because our WecasaPhoneCountryCode is a intersection of
  // CountryCode from libphonenumber-js and CountryCode from react-native-country-picker-modal
  const isValidNumber = isValidPhoneNumber(phoneNumber, countryCode as CountryCodeFromLibPhoneNumber);
  return checkPhoneNumberValidity({
    countryCode,
    dialCode,
    parsedPhoneNumber,
    isPossibleNumber: isValidNumber,
  });
};
